import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Customers } from '../../../_models/customers';



@Component({
  selector: 'app-customers',
  templateUrl: './customers-list.component.html'
})
export class CustomersListComponent implements OnInit {

  title: string;
  subtitle: string;

  deleteModal: boolean;

  searchCustomersForm: FormGroup;

  @Input() customerss: Customers[];
  @Input() currentCustomers: Customers;
  @Input() filterFields: any;
  @Output() searchCustomerss = new EventEmitter<any>();
  @Output() selectCustomers = new EventEmitter<Customers>();
  @Output() deleteCustomers = new EventEmitter<Customers>();

  constructor(
    public router: Router,
    private formBuilder: FormBuilder
  ) {}

  // convenience getter for easy access to form fields
  get f() { return this.searchCustomersForm.controls; }

  ngOnInit() {

    this.title = 'Módulo de Clientes';
    this.subtitle = 'Listado de Clientes';

    this.deleteModal = false;

    this.searchCustomersForm = this.formBuilder.group({
      f_id: this.filterFields['f_id'],
      f_name: this.filterFields['f_name'],
      f_email: this.filterFields['f_email'],
      f_city: this.filterFields['f_city'],
      f_province: this.filterFields['f_province'],
      f_country: this.filterFields['f_country'],
      f_user: Number(localStorage.getItem('user_id'))
    });
  }

  // NOTA: función que coge los parámetros del formulario y los "emite" fuera.
  buttonGetCustomersList(): void {
    console.log('-->--> Pulsado botón Buscar Clientes.');

    // Se inicializa a un id de usuario con el que nunca pueda devolver información al hacer la consulta.
    let userIdAux = 9999999;

    let current_user_id = Number(localStorage.getItem('user_id'));

    // Si existe usuario logueado se coge su id para filtrar en la consulta.
    if (current_user_id !== null && current_user_id !== undefined) {
      userIdAux = current_user_id;
    }

    this.searchCustomersForm.controls.f_user.setValue(userIdAux);

    this.searchCustomerss.emit(this.searchCustomersForm.value);
  }

  buttonCreateCustomers() {
    this.selectCustomers.emit(null);
    this.router.navigate(['/customers-edit']);
  } // End function buttonCreateCustomers

  buttonSetCurrentCustomers(customers: Customers | null) {
    console.log('-> -> Seleccionado Cliente:');
    console.log(customers);

    this.selectCustomers.emit(customers);

    this.router.navigate(['/customers-edit']);
  } // End function buttonSetCurrentCustomers

  buttonDeleteCustomers(customers: Customers) {
    console.log('-> -> Borrar Cliente:');
    console.log(customers);

    this.selectCustomers.emit(customers);

    this.showDeleteModal(true);

  } // End function buttonDeleteCustomers

  showDeleteModal(value: boolean) {
    this.deleteModal = value;

  } // End function showDeleteModal

  confirmDeleteCustomers() {
    this.deleteCustomers.emit(this.currentCustomers);
    this.showDeleteModal(false);
  }
} // End class CustomersListComponent
